<template>
    <div >
        <search></search>
        <div class="search">
        <div class="history">
            <div class="head">
                <span>历史搜索</span>
                <button class="clear" @click="deleteHistory">全部删除</button>
            </div>
            <div class="list">
                <ul>
                    <li v-for="(item,index) of history" :key="index">{{item}}</li>
                </ul>
            </div>
        </div>    
          <!-- <div class="hot">
            <div class="head">
                <span>热门搜索</span>
                <button class="refresh">换一批</button>
            </div>
            <div class="list">
                <ul>
                    <li v-for="(item,index) of hotSearch" :key="index"></li>
                </ul>
            </div>
        </div> -->
        </div>    
    </div>
</template>
<script>
import search from "@/components/search"
export default {
    name: 'Search',
    components:{
        search
    },
    data() {
        return{
            history:[],
            hotSearch:[]
        }
    },
    methods:{
        getHistory() {
            let his = localStorage.getItem('shistory')
             if(his !== "" && his !== null){
                this.history = his.split(",")
                }else{
                    this.history = []
                }
        },
        deleteHistory(){
            localStorage.removeItem('shistory')
            this.getHistory()
        }
    },
    created() {
        this.getHistory()
    }
}
</script>
<style lang="scss" scoped>
    .search{
        font-size: 0.32rem;
        padding: 0.2rem;
        .head{
            display: flex;
            justify-content: space-between;
            margin: 0.1rem 0;
        }
        .list{
            margin-bottom: 0.6rem;
            ul{
                display: flex;
                li{
                    padding: 0.04rem 0.15rem;
                    border: 1px solid #FF6161;
                    color: #FF6161;
                    border-radius: 30px;
                }
            }
        }
        .clear{
            background: url('../assets/icon/delete.png') no-repeat;
            background-size: .4rem;
            background-position: 0;
            padding-left: .5rem;
            border: none;
        }
        .refresh{
             background: url('../assets/icon/refresh.png') no-repeat;
            background-size: .4rem;
            background-position: 0;
            padding-left: .5rem;
            border: none;
        }

    }
</style>